







































import { defineComponent, onMounted, onUnmounted, ComputedRef, computed } from '@vue/composition-api';
import SubTitle from '@/components/NEW-STRUCTURE/desktop/Admin/titles/SubTitle.vue';

import ChannelListData from '@/ts/Channels/ChannelListData';

export default defineComponent({
    components: {
        SubTitle
    },
    props: {
        channel: ChannelListData,
    }, 
    setup({ channel }, { emit, root }) {

    const store = root.$store;

    const channelTabs: ComputedRef<any> = computed(() => {
        return store.getters['Channels/getChannelsTabs'];
    });
      
    const onEditChannel = () => {
        const { EDIT_CHANNEL_INFO } = channelTabs.value;
        emit('changeManagementTab', EDIT_CHANNEL_INFO);
    };

      onUnmounted(() => {
        channel = null;
        });
    
      return {
        onEditChannel,
      };
    
    },
});
